import { useCallback, useMemo } from 'react';
import { useTranslation } from '@shared/core';

export const useRegistryShippingAndHandlingLineLabel = () => {
  const { t, tq } = useTranslation('sharedRegistry');
  const { delivery } = t('shoppingCart');
  const bulkItemSurcharge = useCallback(() => tq`Bulk Item Surcharge`, [tq]);

  const translations = useMemo(() => ({ delivery, bulkItemSurcharge }), [delivery, bulkItemSurcharge]);

  const withAppliedItemCount = useCallback(
    (label: string, appliedItemsCount?: number) => {
      if (!appliedItemsCount) {
        return label;
      }
      return `${label} (${tq.plural(appliedItemsCount, {
        one: tq`applied to ${appliedItemsCount} item`,
        other: tq`applied to ${appliedItemsCount} items`,
      })})`;
    },
    [tq],
  );

  const getDeliveryLineLabel = useCallback((appliedItemsCount?: number) => withAppliedItemCount(translations.delivery(), appliedItemsCount), [translations, withAppliedItemCount]);

  const getSurchargeLineLabel = useCallback(
    (appliedItemsCount?: number) => withAppliedItemCount(translations.bulkItemSurcharge(), appliedItemsCount),
    [translations, withAppliedItemCount],
  );

  return { getDeliveryLineLabel, getSurchargeLineLabel };
};
